// we need to use the fonts' "PostScript" names
// https://docs.expo.dev/develop/user-interface/fonts/#what-is-postscript-name-of-a-font

const PlusJakartaSans_Regular = 'PlusJakartaSans-Regular'
const PlusJakartaSans_Italic = 'PlusJakartaSans-Italic'
const PlusJakartaSans_SemiBold = 'PlusJakartaSans-SemiBold'
const PlusJakartaSans_Bold = 'PlusJakartaSans-Bold'
const PlusJakartaSans_BoldItalic = 'PlusJakartaSans-BoldItalic'
const PlusJakartaSans_ExtraBold = 'PlusJakartaSans-ExtraBold'
const Poppins_Regular = 'Poppins-Regular'
const Poppins_SemiBold = 'Poppins-SemiBold'
const Poppins_Bold = 'Poppins-Bold'
const Inter_Medium = 'Inter-Medium'
const Inter_Bold = 'Inter-Bold'

export { PlusJakartaSans_Regular as 'PlusJakartaSans-Regular' }
export { PlusJakartaSans_Italic as 'PlusJakartaSans-Italic' }
export { PlusJakartaSans_SemiBold as 'PlusJakartaSans-SemiBold' }
export { PlusJakartaSans_Bold as 'PlusJakartaSans-Bold' }
export { PlusJakartaSans_BoldItalic as 'PlusJakartaSans-BoldItalic' }
export { PlusJakartaSans_ExtraBold as 'PlusJakartaSans-ExtraBold' }
export { Poppins_Regular as 'Poppins-Regular' }
export { Poppins_SemiBold as 'Poppins-SemiBold' }
export { Poppins_Bold as 'Poppins-Bold' }
export { Inter_Medium as 'Inter-Medium' }
export { Inter_Bold as 'Inter-Bold' }
